import { createContext, useContext } from 'react'
import { user, UserType } from './user'

export type UserContextType = UserType

export const UserContext = createContext<UserContextType>(user)

export const useUser = () => useContext(UserContext)
